import React, { useState } from "react";
import { Megaphone, X } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const AnnouncementBar = () => {
  const { settings } = useSettings();
  const [closed, setClosed] = useState(false);
  if (!settings?.announcement_enabled || !settings?.announcement_text || closed) return null;
  return (
    <div className="relative text-center text-sm font-medium py-2.5 px-10"
      style={{ background: "linear-gradient(90deg,#10B981,#00FF66)", color: "#04210F" }}
      data-testid="announcement-bar">
      <span className="inline-flex items-center gap-2">
        <Megaphone size={15} /> {settings.announcement_text}
      </span>
      <button onClick={() => setClosed(true)} className="absolute right-3 top-1/2 -translate-y-1/2" data-testid="announcement-close">
        <X size={16} />
      </button>
    </div>
  );
};
